import delegationAssembler from './foodDelegation.assemblers';
import { MODULE_ID } from 'food-benefit.module/common/domain/constants';

class foodDelegationService {
  constructor($http, DelegationService) {
    'ngInject';
    this.http = $http;
    this.delegationService = DelegationService;
  }

  getDelegations(employeeId) {
    return this.delegationService.getDelegations(employeeId, MODULE_ID).then((response) => {
      return delegationAssembler.assemble(response.data);
    });
  }

  updateDelegation(employeeId, delegationToUpdate) {
    return this.delegationService.updateDelegations(employeeId, delegationToUpdate);
  }

  createDelegation(employeeId, delegationToCreate) {
    return this.delegationService.createDelegations(employeeId, delegationToCreate);
  }

  deleteDelegation(employeeId, delegationToCreate) {
    return this.delegationService.cancelDelegation(employeeId, delegationToCreate);
  }

  findDelegationActive(today, delegations, permission) {
    let delegationToReturn = delegations.find(delegation => {
      return this._checkDataDelegation(delegation, today, permission);
    });

    return (delegationToReturn !== undefined) ? delegationToReturn : {};
  }

  _checkDataDelegation(delegation, today, permission) {
    let endDateSmaller = today <= delegation.endDate;
    let startDateGreater = today >= delegation.startDate;
    let isTypePermission = (permission !== undefined) ? delegation.type === permission : true;
    return endDateSmaller && startDateGreater && isTypePermission;
  }
}

export default foodDelegationService;



// WEBPACK FOOTER //
// ./client/app/food-benefit.module/common/delegationRepository/foodDelegationRepository.service.js